<template>
    <!-- DESC：该页面负责登录注册逻辑（具备发邮箱效验） -->
    <div class="login">
        <!-- 左右标题信息 -->
        <div class="bg-logo">
            <img src="../../../public/img/logo.svg" alt="Element logo" @click="$router.push('/')" />
        </div>
        <img src="../../../public/img/lg01.svg" class="lg01">
        <!-- 登录框界面 -->
        <div class="login-box" v-if="isLogin">
            <div class="login-img">
                <img src="../../../public//img//login-img.svg">
            </div>
            <div class="login-input">
                <div class="login-input-title">International Conference Paper Submission System</div>
                <el-input v-model="logininfo.email" placeholder="Email address" class="input-btn">
                    <template #prefix>
                        <el-icon class="el-input__icon">
                            <Message />
                        </el-icon>
                    </template>
                </el-input>
                <el-input v-model="logininfo.passwd" placeholder="Password" class="input-btn" :show-password="true">
                    <template #prefix>
                        <el-icon class="el-input__icon">
                            <lock />
                        </el-icon>
                    </template>
                </el-input>
                <div class="send-btn">
                    <el-button type="primary" class="login-btn" @click="loginfun">Login</el-button>
                    <el-button type="primary" class="reg-btn" @click="isLogin = false">Register</el-button>
                </div>
                <div class="tip">
                    <span style="color: #0f709bba;cursor: pointer;" @click="$router.push('/resetpass')">Existing account, forgotten password?</span>
                    <span style="color: #0f709bba;cursor: pointer;" @click="linkAdmin">Administrators can click here to enter the backend system</span>
                </div>
            </div>
        </div>
        <!-- 注册框界面 -->
        <div class="login-box" v-if="!isLogin">
            <div class="login-img">
                <img src="../../../public//img//login-img.svg">
            </div>
            <div class="login-input reg-input">
                <el-button type="primary" plain :icon="ArrowLeft" circle class="btnback" size="small"
                    @click="isLogin = true" />
                <div class="login-input-title">International Conference Paper Submission System</div>
                <el-input v-model="reginfo.name1" placeholder="First name" class="input-btn">
                    <template #prefix>
                        <el-icon class="el-input__icon">
                            <user />
                        </el-icon>
                    </template>
                </el-input>
                <el-input v-model="reginfo.name2" placeholder="Last name" class="input-btn">
                    <template #prefix>
                        <el-icon class="el-input__icon">
                            <user />
                        </el-icon>
                    </template>
                </el-input>
                <el-input v-model="reginfo.email" placeholder="Email" class="input-btn">
                    <template #prefix>
                        <el-icon>
                            <message />
                        </el-icon>
                    </template>
                </el-input>
                <el-input v-model="reginfo.passwd" placeholder="Password" class="input-btn" :show-password="true">
                    <template #prefix>
                        <el-icon class="el-input__icon">
                            <lock />
                        </el-icon>
                    </template>
                </el-input>
                <el-input v-model="reginfo.retpasswd" placeholder="Retype Password" class="input-btn"
                    :show-password="true">
                    <template #prefix>
                        <el-icon class="el-input__icon">
                            <lock />
                        </el-icon>
                    </template>
                </el-input>
                <div class="send-btn reg-btn">
                    <el-button type="primary" class="reg-btn" @click="regfun">Register</el-button>
                </div>
            </div>
        </div>
        <div class="login-desc">
            <div class="desc-advantage">
                <el-icon>
                    <Clock />
                </el-icon>
                <span>Convenience and efficiency of submission</span>
            </div>
            <div class="desc-advantage">
                <el-icon>
                    <Connection />
                </el-icon>
                <span>Global and Accessibility</span>
            </div>
            <div class="desc-advantage">
                <el-icon>
                    <Notification />
                </el-icon>
                <span>Transparency and Tracking</span>
            </div>
            <div class="desc-advantage">
                <el-icon>
                    <Coin />
                </el-icon>
                <span>Data Management and Security</span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { User, Lock, ArrowLeft, Message, Clock, Connection, Notification, Coin } from '@element-plus/icons-vue'
import { onMounted, ref, inject } from 'vue'
import { ElNotification } from 'element-plus'
import { ElMessage } from 'element-plus'
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import axios from "axios";
import "animate.css";
import request from "../../network/request"


const router = useRouter();
const route = useRoute();
const store = useStore();

// 登录信息
const logininfo = ref({ email: "", passwd: "" })
// 注册信息
const reginfo = ref({ name1: "", name2: "", email: "", passwd: "", retpasswd: "" })
// 是否登录 
const isLogin = ref(true)
const checkLoginAndConnect = inject('checkLoginAndConnect');

onMounted(() => {
    // 判断是否为注册
    if (route.query.isLogin) {
        let payload = JSON.parse(route.query.isLogin)
        isLogin.value = payload
    }
})

// 刷新消息
const flush = () => {
    request.get("/message/flush").then((res) => {
        if (res.code == 200) {
            store.commit("setUnreadCount", res.data.unreadCount)
            if (res.data.lastCount > 0) {
                ElMessage.success({
                    message: `You have ${res.data.lastCount} new messages`,
                    type: 'success',
                })
            }
        }
    })
}

// 登录逻辑
const loginfun = () => {
    request.post("/user/login", {
        email: logininfo.value.email,
        passwd: logininfo.value.passwd,
    }, {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }).then((res) => {
        if (res.code == 200) {
            // 存入vuex全局管理
            let user = res.data
            store.commit("setUser", user)
            store.commit("setMenuItemIndex", 5)
            ElNotification({
                title: 'login succeeded',
                message: 'About to jump to the homepage',
                type: 'success',
                duration: 2000
            });
            flush()
            // 跳转上一次登录给拦截下来的页面
            const historyurl = store.state.historyurl
            router.push(historyurl)
            checkLoginAndConnect();
        }
        else if (res.code == 401) {
            ElNotification({
                title: 'login failed',
                message: 'Account or password incorrect',
                type: 'warning',
                duration: 2000,
            });
        }
        else if (res.code == 402) {
            ElNotification({
                title: 'login failed',
                message: 'The account is not valid, please activate it first',
                type: 'warning',
                duration: 3000,
            });
        }
    })
}
// 注册逻辑
const regfun = () => {
    if (reginfo.value.passwd != reginfo.value.retpasswd) {
        ElNotification({
            title: 'register failed',
            message: 'Two different password inputs',
            type: 'warning',
            duration: 5000,
        });
        return
    }
    if (reginfo.value.passwd.length < 6) {
        ElNotification({
            title: 'register failed',
            message: 'The password length cannot be less than 6 digits',
            type: 'warning',
            duration: 5000,
        });
        return
    }

    request.post("/user/reg", {
        email: reginfo.value.email,
        firstname: reginfo.value.name1,
        lastname: reginfo.value.name2,
        passwd: reginfo.value.passwd,
    }).then((res) => {
        if (res.code == 200) {
            ElNotification({
                title: 'register success',
                message: 'An email has been sent to your email, please activate it first',
                type: 'success',
                duration: 10000,
            });
            isLogin.value = true
        }
        else if (res.code == 401) {
            ElNotification({
                title: 'register failed',
                message: 'Incorrect email format',
                type: 'warning',
                duration: 5000,
            });
        }
        else if (res.code == 402) {
            ElNotification({
                title: 'register failed',
                message: 'This email has been registered',
                type: 'warning',
                duration: 5000,
            });
        }
    })
}

const linkAdmin = ()=>{
    window.location.href="https://www.gdstinfo.cn/confadm"
}

</script>


<style lang="scss" scoped>
.login {
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    flex-direction: column;
    background: linear-gradient(180deg, #bdddf7c0 0%, rgba(255, 255, 255, 1) 100%);
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
    .lg01{
        position: fixed;
        width: 20%;
        opacity: .3;
        bottom: -5%;
        right: -5%;
    }
    .desc-maintext {
        margin-right: 30px;
        font-size: 30px;
        background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        font-weight: 700;
        display: flex;
        position: absolute;
        top: 32px;
        right: 40px;
    }

    .desc-secondtext {
        .secondtext-line {
            border-bottom: 10px solid #2298e621;
            display: inline-block;
            width: 100%;
            height: 3px;
            position: relative;
            bottom: 30px;
        }
    }

    .login-desc {
        display: flex;

        .desc-advantage {
            display: flex;
            align-items: center;
            background: linear-gradient(90deg, rgba(134, 198, 250, 0.178) 10%, rgba(255, 255, 255, 0.151) 60%);
            padding: 7px;
            border-radius: 5px;
            color: #347ea9a1;
            font-size: 15px;
            margin-right: 100px;

            .el-icon {
                font-size: 25px;
                margin-right: 10px;
                color: #2288c37d;
            }
        }
    }

    .login-background {
        width: 100%;
        height: 100%;
        z-index: -1;
        position: absolute;
    }

    .login-box {
        height: 430px;
        width: 820px;
        background: rgb(255, 255, 255);
        border-radius: 20px;
        display: flex;
        box-shadow: 1px 1px 15px #2121211d;
        margin-top: 90px;
        margin-bottom: 150px;
    }

    .login-img {
        width: 50%;
        // background: #62a7e1;
        background: linear-gradient(180deg, rgba(111, 181, 238, 0.753) 10%, rgba(255, 255, 255, 1) 70%);
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            width: 90%;
        }
    }

    .login-input {
        flex: 1;
        padding: 20px;

        .login-input-title {
            text-align: center;
            margin-bottom: 40px;
            color: #4584b7ce;
            font-size: 20px;
            margin-top: 35px;
            font-weight: 700;
        }

        .input-btn {
            width: 350px;
            margin-bottom: 35px;
        }

        .send-btn {
            display: flex;

            * {
                flex: 1;
            }
        }

        .reg-btn {
            padding: 0 50px;
        }

        .tip {
            font-size: 12px;
            color: #4646468a;
            text-align: center;
            margin-top: 38px;
            display: flex;
            flex-direction: column;

            span {
                margin-bottom: 10px;
            }
        }
    }

    .reg-input {
        border-radius: 20px;
        top: -50px;
        position: relative;
        height: 500px;
        background: #fff;
        box-shadow: 0 0 3px #00000017;

        .btnback {
            position: absolute;
            left: 20px;
            top: 20px;
        }
    }
}

.bg-title {
    display: flex;
    color: #4584b7ae;
    font-weight: 700;
    position: absolute;
    top: 32px;
    right: 40px;

    span {
        margin-right: 30px;
        cursor: pointer;
    }
}

.bg-logo {
    display: flex;
    color: #4584b7ae;
    font-weight: 700;
    position: absolute;
    top: 32px;
    left: 40px;

    img {
        width: 145px;
        cursor: pointer;
    }
}
</style>